import { JSX, useEffect } from "react";
import UICustomizationViewCategoryListSettings from "../../../../../components/ui-customization-settings/UICustomizationViewCategoryListSettings";
import { useRouteContext } from "../../../../../hooks/use-route-context/UseRouteContext";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { UICustomizationModeTypeEnum, UserFieldType } from "../UserFieldTypes";
import { useQueryNotifications } from "../../../../../queries/UseQueryNotifications";
import { useUICustomizationPreset } from "../../../../../queries/ui-customization/UseUICustomizationPreset";
import { toPresetField } from "../../../../ui-customization-preset-admin-view/ui-customization-preset-editor/UICustomizationPresetEditorEditorUtils";

type CustomViewProps = {
    organizationID: number | undefined;
};
export function CustomView({
    organizationID
}: CustomViewProps): JSX.Element {
    const routeContext = useRouteContext();
    const { t } = useTranslation();

    const {
        getValues,
        setValue
    } = useFormContext<UserFieldType>();

    const [
        uiCustomizationMode,
        uiCustomizationPresetID,
        customizationSettings
    ] = getValues([
        "uiCustomizationMode",
        "uiCustomizationPresetID",
        "customizationSettings"
    ]);

    const {
        data: presetModel,
        status: presetStatus
    } = useQueryNotifications(useUICustomizationPreset)({
        groupID: routeContext.groupID as number,
        presetID: uiCustomizationPresetID as number,
        enabled: (uiCustomizationPresetID ?? 0) > 0 &&
        uiCustomizationMode === UICustomizationModeTypeEnum.Custom
    });

    useEffect(() => {
        if (presetStatus === "success" && presetModel) {
            const preset = toPresetField(presetModel);
            setValue("customizationSettings", preset.customizationSettings);
        }
    }, [
        presetStatus,
        presetModel,
        setValue
    ]);

    return (
        <UICustomizationViewCategoryListSettings isLoading={false} />
    );
}
